import React, { useEffect } from 'react'
import { useLayout, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import SearchNav from './header-search-nav-pages'
import UserNav from './header-user-nav'
import MegaMenu from './header-mega-menu'
import HeaderLogo from './header-logo'
import { DesktopStateActionType, useHeaderContext } from './header-context'
import Overlay from '@dustin-web/microsite-components/src/overlay'
import SiteLangSwitcher from './header-site-lang-switcher'
import MainNav from './header-main-nav'
import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { getLayerClassName } from '@dustin-web/microsite-components/src/utils/get-layer-class-name'
import OrderHistoryBtn from '@dustin-web/microsite-baselayout/src/components/header/components/header-order-history-btn'

const HeaderDesktop = () => {
  const { desktop, dispatchDesktop } = useHeaderContext()
  const { header } = useLayout()
  const { sourcingCompany } = useSiteContext()
  const { translate } = useTranslations()
  const { isAuthenticated } = useAuth()

  // Close all active menus on Escape
  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.code === 'Escape') {
        const element = e.target as HTMLElement | undefined
        element?.blur()
        dispatchDesktop({
          type: DesktopStateActionType.CLOSE_ALL_MENUS,
        })
      }
    }
    document.addEventListener('keyup', handleKeyUp)
    return () => {
      document.removeEventListener('keyup', handleKeyUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const showOverlay = desktop.activeMegaMenu.length > 0 || desktop.activeMenus.includes('search')

  return (
    <>
      <header className="c-header">
        <nav aria-label="main">
          <div className="c-header__search c-header__section">
            <div className="c-header__container container">
              <HeaderLogo />
              <SearchNav />
              <UserNav />
            </div>
          </div>
          <div className="c-header__navigation c-header__section">
            <div className="c-header__container c-header__container--top-aligned container">
              <MainNav sourcingCompany={sourcingCompany} isProductOpen={header.isProductOpen} />
              <OrderHistoryBtn isAuthenticated={isAuthenticated} text={translate('OrderHistory')} />
              <SiteLangSwitcher />
            </div>
          </div>
          <MegaMenu type={'category'} />
          <MegaMenu type={'brand'} />
          <MegaMenu type={'solutions'} />
        </nav>
      </header>
      {showOverlay && <Overlay show={showOverlay} className={getLayerClassName('dialog')} />}
      {/* For print */}
      <div
        className="d-none d-print-block u-bg-white u-py-16 u-attach-section u-relative"
        style={{ zIndex: 1 }}>
        <div className="container">
          <HeaderLogo />
        </div>
      </div>
    </>
  )
}

export default HeaderDesktop
